// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg xmlns=%27http://www.w3.org/2000/svg%27 width=%2716%27 height=%2716%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27currentColor%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27><path d=%27m6 9 6 6 6-6%27></path></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* --- Multiselect Styling --- */


/* Selected items container */
.multiSelectContainer .selected-container {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  max-height: 80px;
  overflow-y: auto; /* scroll if many items */
  padding: 4px 4px 4px 4px;
}

/* Individual selected item */
.multiSelectContainer .selected-item {
  display: flex;
  align-items: center;
  background-color: #E5F0FF;
  border-radius: 4px;
  padding: 2px 6px;
  font-size: 14px;
}

/* Remove cross styling if needed */
.multiSelectContainer .selected-item span.remove {
  cursor: pointer;
  margin-left: 4px;
  font-weight: bold;
}

/* Search input */
.multiSelectContainer .search-wrapper {
  border: none !important;
  box-shadow: none !important;
  min-height: 36px;
  padding: 2px 4px;
  z-index: 2;
}

/* Placeholder */
.multiSelectContainer .placeholder {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 8px;
  pointer-events: none;
  font-size: 14px;
  color: #838FB4;
}

/* Dropdown options container */
.multiSelectContainer .optionContainer {
  max-height: 200px;
  overflow-y: auto;
  position: absolute;
  top: calc(100% + 4px); /* dropdown starts below the selected box */
  left: 0;
  width: 100%;
  background-color: #fff;
  border: 1px solid #C7C7C7;
  border-radius: 4px;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
  z-index: 9999;
}

/* Scrollbar styling for selected items and dropdown */
.multiSelectContainer .selected-container::-webkit-scrollbar,
.multiSelectContainer .optionContainer::-webkit-scrollbar {
  width: 6px;
}

.multiSelectContainer .selected-container::-webkit-scrollbar-thumb,
.multiSelectContainer .optionContainer::-webkit-scrollbar-thumb {
  background-color: rgba(0,0,0,0.2);
  border-radius: 3px;
}


/* --- Other Containers --- */
.env-info-container {
  background-color: #C7C7C7;
  border: 1px solid #C7C7C7;
  border-radius: 5px;
}

/* Non-editable fields */
.non-editable {
  pointer-events: none;
  background-color: #F6F6F6;
  color: #838383;
}

/* Label styling */
.unl-label-p {
  font-weight: 600;
}

/* --- Header Styling --- */
.form-header {
  margin-bottom: 20px;
  color: #ffffff;
  text-align: left;
}

.form-title {
  color: #0066CC;
  font-size: 16px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 4px;
}

.icon {
  width: 24px;
  height: 24px;
}

.form-description {
  font-size: 14px;
  color: #838FB4;
  margin-bottom: 20px;
}

/* --- Breadcrumb --- */
.breadcrumb-container {
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 4px;
}

.step {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 100px;
  font-weight: bold;
  font-size: 12px;
  color: #fff;
}

.step.deactive { background-color: #838FB4; }
.step.active { background-color: #005EEF; }

.breadcrumb-separator { margin: 0 2px; color: #838FB4; }

.active-step { color: #005EEF; font-weight: 400; font-size: 14px; }
.deactive-step { color: #838FB4; font-weight: 400; font-size: 14px; }

.back-link {
  font-size: 14px;
  text-decoration: none;
  color: #A9ACB4;
  display: inline-block;
  margin-bottom: 8px;
}

/* --- Button Styling --- */
.button-container {
  display: flex;
  justify-content: flex-end;
  gap: 20px;
}

.btn.apply-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: 75px;
  height: 36px;
  padding: 8px;
  border-radius: 4px;
  background: #0066CC !important;
  color: #FFFFFF;
  font-size: 14px;
  font-weight: 400;
  box-shadow:
    0px 0px 0px 0.5px #0066CC1F,
    0px 1px 2.5px 0px #0066CC3D;
}
.btn.apply-btn:hover { background-color: #7690a9; }

.btn.reset-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: 73px;
  height: 36px;
  padding: 8px;
  border-radius: 4px;
  background: #FFFFFF;
  font-size: 14px;
  font-weight: 400;
  color: #0066CC;
  box-shadow:
    0px 0px 0px 0.5px #0000000D,
    0px 0.5px 2.5px 0px #0000004D;
}
.btn.reset-btn:hover { background-color: rgba(33, 150, 243, 0.1); }

/* Input placeholders */
.multiSelectContainer input::placeholder {
  font-size: 14px;
  color: #838FB4;
}

.form-select {
  font-size: 14px;
  color: #0066CC;
  height: 44px;
}

.form-control::placeholder {
  font-size: 14px;
  color: #838FB4;
}

.form-control,
.form-control-app-desc {
  height: 44px;
}

.form-container textarea {
  height: 59px;
}

.add-user-section {
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 8px 4px 10px;
}

.add-user-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 4px 8px;
}

.add-user-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  border: none;
  background: transparent;
  color: #0066CC;
  font-size: 14px;
  font-weight: 500;
  padding: 4px 6px;
}

.add-user-btn:hover {
  color: #004a99;
}

.add-user-row {
  align-items: flex-end;
}

.add-user-delete-col {
  display: flex;
  align-items: center;
  min-height: 44px;
}

.add-user-delete-btn {
  border: none;
  background: transparent;
  color: #111111;
  padding: 8px;
  line-height: 1;
}

.add-user-delete-btn:hover {
  color: #004a99;
}

.add-user-error {
  color: red;
  margin: 6px 4px 0;
}

/* React-select control (if used) */
.css-13cymwt-control {
  min-height: 44px !important;
  border: 1px solid #dee2e6 !important;
}

.env-placeholder {
  color: #838FB4 !important;  /* same as other placeholders */
}

.env-dropdown-container {
  position: relative;
  width: 100%;
}

.env-dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  background-color: white;
  z-index: 1000;
  max-height: 200px;
  overflow-y: auto;
  margin-top: 2px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.15);
}

.env-dropdown-item {
  padding: 0.25rem 0.75rem;
}

.env-dropdown-label {
  display: flex;
  align-items: center;
  cursor: pointer;
  color:#0066CC;
}

.env-dropdown-checkbox {
  margin-right: 0.5rem;
  accent-color: #0066CC;
}


/* Custom GroupMultiselect dropdown */

.groupMultiSelectModel{
  height: 45px;
  /* padding: 0 12px; */
  border: 1px solid #dee2e6;
  border-radius: 6px;
  background-color: white;
  cursor: pointer;
  /* position: relative; */
}

.groupMultiSelectModel .searchWrapper{
  height: 45px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  overflow-y: auto;
  /* overflow: hidden; 
  padding-left: 120px */
}

.multiSelectContainer li:hover {
  background: #e7f3ff;
  color: #212529;
}

.multiselect-container ul {
  top: auto !important;
  bottom: 100% !important;
  margin-bottom: 10%;
}

span.icon_down_dir {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: 16px 16px;
  width: 18px;
  height: 18px;
  display: inline-block;
}

span.icon_down_dir:before {
  content: "";
}

/* Overlay container for showing selected chips */
.groupMultiSelectModel_container .overlay-selected {
  /* position: absolute;
  inset: 0;
  pointer-events: none;
  display: flex;
  align-items: center;
  padding-left: 0.75rem;
  background-color: #fff;
  z-index: 999; */

  position: absolute;
  top: 55%;
  left: 0.75rem;
  right: 2rem; /* leave space for dropdown arrow */
  transform: translateY(-50%);
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
  background: transparent;
  z-index: 2; 
  pointer-events: none; 
}

.groupMultiSelectModel_container .overlay-selected .chip {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  font-size: 12px;
  border-radius: 4px;
  background: rgba(0, 102, 204, 0.15);
  color: #0066cc;
  pointer-events: auto;
}

.groupMultiSelectModel_container .overlay-selected .chip-remove {
  cursor: pointer;
  opacity: 0.8;
  pointer-events: auto;
}

.groupMultiSelectModel_container .overlay-selected .chip-remove:hover {
  opacity: 1;
}

.groupMultiSelectModel_container .chip-more {
  cursor: pointer;
  transition: background 0.2s;
}

.groupMultiSelectModel_container .chip-more:hover {
  background: rgba(0, 102, 204, 0.25);
}

.groupMultiSelectModel_container .max-h-200 {
  max-height: 200px;
}

.groupMultiSelectModel_container .multiSelectContainer input {
  margin-top: -3px;
}

.groupMultiSelectModel_container .searchBoxOnboarding{
  margin-left: 85%;
  width: 18%;
}
`, "",{"version":3,"sources":["webpack://./src/components/OnboardingForm.css"],"names":[],"mappings":"AAAA,gCAAgC;;;AAGhC,6BAA6B;AAC7B;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;EAChB,gBAAgB,EAAE,yBAAyB;EAC3C,wBAAwB;AAC1B;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,mCAAmC;AACnC;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;AACZ;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,SAAS;EACT,oBAAoB;EACpB,eAAe;EACf,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB,EAAE,2CAA2C;EAClE,OAAO;EACP,WAAW;EACX,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,qCAAqC;EACrC,aAAa;AACf;;AAEA,sDAAsD;AACtD;;EAEE,UAAU;AACZ;;AAEA;;EAEE,iCAAiC;EACjC,kBAAkB;AACpB;;;AAGA,6BAA6B;AAC7B;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,wBAAwB;AACxB;EACE,oBAAoB;EACpB,yBAAyB;EACzB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;;AAEA,iBAAiB,yBAAyB,EAAE;AAC5C,eAAe,yBAAyB,EAAE;;AAE1C,wBAAwB,aAAa,EAAE,cAAc,EAAE;;AAEvD,eAAe,cAAc,EAAE,gBAAgB,EAAE,eAAe,EAAE;AAClE,iBAAiB,cAAc,EAAE,gBAAgB,EAAE,eAAe,EAAE;;AAEpE;EACE,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB;;+BAE6B;AAC/B;AACA,uBAAuB,yBAAyB,EAAE;;AAElD;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd;;iCAE+B;AACjC;AACA,uBAAuB,yCAAyC,EAAE;;AAElE,uBAAuB;AACvB;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA,mCAAmC;AACnC;EACE,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;EACE,yBAAyB,GAAG,+BAA+B;AAC7D;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;EACvB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;;AAGA,qCAAqC;;AAErC;EACE,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB;uBACqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,yDAA0Q;EAC1Q,4BAA4B;EAC5B,2BAA2B;EAC3B,0BAA0B;EAC1B,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA,iDAAiD;AACjD;EACE;;;;;;;iBAOe;;EAEf,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,WAAW,EAAE,mCAAmC;EAChD,2BAA2B;EAC3B,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,mCAAmC;EACnC,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ","sourcesContent":["/* --- Multiselect Styling --- */\n\n\n/* Selected items container */\n.multiSelectContainer .selected-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  max-height: 80px;\n  overflow-y: auto; /* scroll if many items */\n  padding: 4px 4px 4px 4px;\n}\n\n/* Individual selected item */\n.multiSelectContainer .selected-item {\n  display: flex;\n  align-items: center;\n  background-color: #E5F0FF;\n  border-radius: 4px;\n  padding: 2px 6px;\n  font-size: 14px;\n}\n\n/* Remove cross styling if needed */\n.multiSelectContainer .selected-item span.remove {\n  cursor: pointer;\n  margin-left: 4px;\n  font-weight: bold;\n}\n\n/* Search input */\n.multiSelectContainer .search-wrapper {\n  border: none !important;\n  box-shadow: none !important;\n  min-height: 36px;\n  padding: 2px 4px;\n  z-index: 2;\n}\n\n/* Placeholder */\n.multiSelectContainer .placeholder {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  left: 8px;\n  pointer-events: none;\n  font-size: 14px;\n  color: #838FB4;\n}\n\n/* Dropdown options container */\n.multiSelectContainer .optionContainer {\n  max-height: 200px;\n  overflow-y: auto;\n  position: absolute;\n  top: calc(100% + 4px); /* dropdown starts below the selected box */\n  left: 0;\n  width: 100%;\n  background-color: #fff;\n  border: 1px solid #C7C7C7;\n  border-radius: 4px;\n  box-shadow: 0 4px 6px rgba(0,0,0,0.1);\n  z-index: 9999;\n}\n\n/* Scrollbar styling for selected items and dropdown */\n.multiSelectContainer .selected-container::-webkit-scrollbar,\n.multiSelectContainer .optionContainer::-webkit-scrollbar {\n  width: 6px;\n}\n\n.multiSelectContainer .selected-container::-webkit-scrollbar-thumb,\n.multiSelectContainer .optionContainer::-webkit-scrollbar-thumb {\n  background-color: rgba(0,0,0,0.2);\n  border-radius: 3px;\n}\n\n\n/* --- Other Containers --- */\n.env-info-container {\n  background-color: #C7C7C7;\n  border: 1px solid #C7C7C7;\n  border-radius: 5px;\n}\n\n/* Non-editable fields */\n.non-editable {\n  pointer-events: none;\n  background-color: #F6F6F6;\n  color: #838383;\n}\n\n/* Label styling */\n.unl-label-p {\n  font-weight: 600;\n}\n\n/* --- Header Styling --- */\n.form-header {\n  margin-bottom: 20px;\n  color: #ffffff;\n  text-align: left;\n}\n\n.form-title {\n  color: #0066CC;\n  font-size: 16px;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.icon {\n  width: 24px;\n  height: 24px;\n}\n\n.form-description {\n  font-size: 14px;\n  color: #838FB4;\n  margin-bottom: 20px;\n}\n\n/* --- Breadcrumb --- */\n.breadcrumb-container {\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.step {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  border-radius: 100px;\n  font-weight: bold;\n  font-size: 12px;\n  color: #fff;\n}\n\n.step.deactive { background-color: #838FB4; }\n.step.active { background-color: #005EEF; }\n\n.breadcrumb-separator { margin: 0 2px; color: #838FB4; }\n\n.active-step { color: #005EEF; font-weight: 400; font-size: 14px; }\n.deactive-step { color: #838FB4; font-weight: 400; font-size: 14px; }\n\n.back-link {\n  font-size: 14px;\n  text-decoration: none;\n  color: #A9ACB4;\n  display: inline-block;\n  margin-bottom: 8px;\n}\n\n/* --- Button Styling --- */\n.button-container {\n  display: flex;\n  justify-content: flex-end;\n  gap: 20px;\n}\n\n.btn.apply-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  width: 75px;\n  height: 36px;\n  padding: 8px;\n  border-radius: 4px;\n  background: #0066CC !important;\n  color: #FFFFFF;\n  font-size: 14px;\n  font-weight: 400;\n  box-shadow:\n    0px 0px 0px 0.5px #0066CC1F,\n    0px 1px 2.5px 0px #0066CC3D;\n}\n.btn.apply-btn:hover { background-color: #7690a9; }\n\n.btn.reset-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  width: 73px;\n  height: 36px;\n  padding: 8px;\n  border-radius: 4px;\n  background: #FFFFFF;\n  font-size: 14px;\n  font-weight: 400;\n  color: #0066CC;\n  box-shadow:\n    0px 0px 0px 0.5px #0000000D,\n    0px 0.5px 2.5px 0px #0000004D;\n}\n.btn.reset-btn:hover { background-color: rgba(33, 150, 243, 0.1); }\n\n/* Input placeholders */\n.multiSelectContainer input::placeholder {\n  font-size: 14px;\n  color: #838FB4;\n}\n\n.form-select {\n  font-size: 14px;\n  color: #0066CC;\n  height: 44px;\n}\n\n.form-control::placeholder {\n  font-size: 14px;\n  color: #838FB4;\n}\n\n.form-control,\n.form-control-app-desc {\n  height: 44px;\n}\n\n.form-container textarea {\n  height: 59px;\n}\n\n.add-user-section {\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  padding: 8px 4px 10px;\n}\n\n.add-user-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 4px 8px;\n}\n\n.add-user-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  border: none;\n  background: transparent;\n  color: #0066CC;\n  font-size: 14px;\n  font-weight: 500;\n  padding: 4px 6px;\n}\n\n.add-user-btn:hover {\n  color: #004a99;\n}\n\n.add-user-row {\n  align-items: flex-end;\n}\n\n.add-user-delete-col {\n  display: flex;\n  align-items: center;\n  min-height: 44px;\n}\n\n.add-user-delete-btn {\n  border: none;\n  background: transparent;\n  color: #111111;\n  padding: 8px;\n  line-height: 1;\n}\n\n.add-user-delete-btn:hover {\n  color: #004a99;\n}\n\n.add-user-error {\n  color: red;\n  margin: 6px 4px 0;\n}\n\n/* React-select control (if used) */\n.css-13cymwt-control {\n  min-height: 44px !important;\n  border: 1px solid #dee2e6 !important;\n}\n\n.env-placeholder {\n  color: #838FB4 !important;  /* same as other placeholders */\n}\n\n.env-dropdown-container {\n  position: relative;\n  width: 100%;\n}\n\n.env-dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 100%;\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem;\n  background-color: white;\n  z-index: 1000;\n  max-height: 200px;\n  overflow-y: auto;\n  margin-top: 2px;\n  box-shadow: 0 2px 6px rgba(0,0,0,0.15);\n}\n\n.env-dropdown-item {\n  padding: 0.25rem 0.75rem;\n}\n\n.env-dropdown-label {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  color:#0066CC;\n}\n\n.env-dropdown-checkbox {\n  margin-right: 0.5rem;\n  accent-color: #0066CC;\n}\n\n\n/* Custom GroupMultiselect dropdown */\n\n.groupMultiSelectModel{\n  height: 45px;\n  /* padding: 0 12px; */\n  border: 1px solid #dee2e6;\n  border-radius: 6px;\n  background-color: white;\n  cursor: pointer;\n  /* position: relative; */\n}\n\n.groupMultiSelectModel .searchWrapper{\n  height: 45px;\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  overflow-y: auto;\n  /* overflow: hidden; \n  padding-left: 120px */\n}\n\n.multiSelectContainer li:hover {\n  background: #e7f3ff;\n  color: #212529;\n}\n\n.multiselect-container ul {\n  top: auto !important;\n  bottom: 100% !important;\n  margin-bottom: 10%;\n}\n\nspan.icon_down_dir {\n  background-image: url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><path d='m6 9 6 6 6-6'></path></svg>\");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 16px 16px;\n  width: 18px;\n  height: 18px;\n  display: inline-block;\n}\n\nspan.icon_down_dir:before {\n  content: \"\";\n}\n\n/* Overlay container for showing selected chips */\n.groupMultiSelectModel_container .overlay-selected {\n  /* position: absolute;\n  inset: 0;\n  pointer-events: none;\n  display: flex;\n  align-items: center;\n  padding-left: 0.75rem;\n  background-color: #fff;\n  z-index: 999; */\n\n  position: absolute;\n  top: 55%;\n  left: 0.75rem;\n  right: 2rem; /* leave space for dropdown arrow */\n  transform: translateY(-50%);\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 4px;\n  background: transparent;\n  z-index: 2; \n  pointer-events: none; \n}\n\n.groupMultiSelectModel_container .overlay-selected .chip {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 8px;\n  font-size: 12px;\n  border-radius: 4px;\n  background: rgba(0, 102, 204, 0.15);\n  color: #0066cc;\n  pointer-events: auto;\n}\n\n.groupMultiSelectModel_container .overlay-selected .chip-remove {\n  cursor: pointer;\n  opacity: 0.8;\n  pointer-events: auto;\n}\n\n.groupMultiSelectModel_container .overlay-selected .chip-remove:hover {\n  opacity: 1;\n}\n\n.groupMultiSelectModel_container .chip-more {\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.groupMultiSelectModel_container .chip-more:hover {\n  background: rgba(0, 102, 204, 0.25);\n}\n\n.groupMultiSelectModel_container .max-h-200 {\n  max-height: 200px;\n}\n\n.groupMultiSelectModel_container .multiSelectContainer input {\n  margin-top: -3px;\n}\n\n.groupMultiSelectModel_container .searchBoxOnboarding{\n  margin-left: 85%;\n  width: 18%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
